import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  FormGroup,
  FormControlLabel,
  Switch,
  Typography,
} from '@material-ui/core'
import { FaSun, FaRegSun, FaMoon,FaRegMoon } from 'react-icons/fa'

const ToggleSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  margin: "0 5px 0 5px",
  display: "flex",
  '&:active': {
    "& .MuiSwitch-thumb": {
      width: 15
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)"
    }
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#25aae1"
      }
    }
  },
  "& .MuiSwitch-thumb": {
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    // backgroundColor: "#8a8a8a"
    backgroundColor: "#ffa32b"
  }
}))

const DarkThemeSwitch = (props) => {
  const localDark = JSON.parse(localStorage.getItem("darkMode"))
  const [checked, setChecked] = useState(localDark !== null ? localDark : true)

  const handleToggle = () => {
    console.log('hello')
    setChecked(!checked)

    props.darkThemeSwitch()
  }
  
  return (    
    <div style={{display: "flex", alignItems: "center", justifyContent: "space-evenly"}}>
        {checked ? <FaRegSun style={{color: "#6e6e6e"}}/> : <FaSun />}
        <ToggleSwitch checked={checked} onChange={handleToggle}/>
        {checked ? <FaMoon /> : <FaRegMoon style={{color: "#6e6e6e"}}/>}
    </div>
    // <FormControlLabel 
    //   control={
    //     <ToggleSwitch checked={checked} onChange={handleToggle} />
    //   }      
    // />    
  )
}

export default DarkThemeSwitch
